import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

/**
 * Diálogo modal accesible.
 * - Cierra con Escape y al hacer click en el fondo.
 * - Bloquea el scroll del fondo mientras está abierto.
 * - tone del ícono: 'primary' | 'danger'
 */
export default function Modal({ open, onClose, title, description, icon, tone = 'primary', children, actions }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        ref={ref}
      >
        {icon && (
          <div className={`modal-icon-wrap ${tone === 'danger' ? 'modal-icon-danger' : ''}`} aria-hidden="true">
            {icon}
          </div>
        )}
        {title && <h2 className="modal-title">{title}</h2>}
        {description && <p className="modal-desc">{description}</p>}
        {children}
        {actions && <div className="modal-actions">{actions}</div>}
      </div>
    </div>,
    document.body
  );
}